import * as React from 'react';
import * as CSSModules from 'react-css-modules';

const styles = require('./plan.less');

@CSSModules(styles)
class Plan extends React.Component<{}> {
    render() {
        return <>{(window.location.href = __('routes.plan'))}</>;
    }
}

export { Plan };
